// extracted by mini-css-extract-plugin
module.exports = {"text":"headlineSkins-large-text-f703027c"};